import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, MobilePageHeader, MobilePageDescription } from "../index";
import styled from "styled-components";

function isAndroidNonChrome() {
  const ua = navigator.userAgent || "";
  const isAndroid = /android/i.test(ua);
  const isChrome =
    /Chrome\//.test(ua) &&
    !/Chromium\/|EdgA?\/|OPR\/|YaBrowser\/|SamsungBrowser\//.test(ua);
  return isAndroid && !isChrome;
}

function buildIntentUrl() {
  const { hostname, pathname, search } = window.location;
  return `intent://${hostname}${pathname}${search}#Intent;scheme=https;package=com.android.chrome;end`;
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: #ffffff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
`;

export default function ChromePrompt() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !isAndroidNonChrome()) return null;

  return (
    <Overlay>
      <MobilePageHeader>{t("views.chrome_prompt.header")}</MobilePageHeader>
      <MobilePageDescription>{t("views.chrome_prompt.desc")}</MobilePageDescription>
      <Button tag="a" href={buildIntentUrl()} display="block">
        {t("views.chrome_prompt.btn_open")}
      </Button>
      <Button type="flat" display="block" onClick={() => setDismissed(true)}>
        {t("views.chrome_prompt.btn_continue")}
      </Button>
    </Overlay>
  );
}
